import { IMediaModel, channelTagsFromMedia } from "@nf/common";
import { CHANNELS, CountryCode } from "@nf/constants";
import { compareStrings } from "@nf/helpers";
import { useTranslation } from "next-i18next";

const getMediaChannelInfo = (media: IMediaModel) => {
  const channel = channelTagsFromMedia(media);
  const countries = media?.Countries ?? [];

  return {
    isKids: channel === CHANNELS.KIDS,
    isDanskFilmskat: channel === CHANNELS.DANSK_FILMSKAT,
    isDanish: countries.some((country) =>
      compareStrings(country.Code, CountryCode.Danish)
    ),
    isFinnish: countries.some((country) =>
      compareStrings(country.Code, CountryCode.Finnish)
    ),
  };
};

export const useMediaMetaTitle = (media: IMediaModel) => {
  const { t } = useTranslation("translations");
  const { isDanish, isFinnish, isDanskFilmskat, isKids } =
    getMediaChannelInfo(media);

  if (!media.IsPlayable) {
    return t("web_meta_title_not_available", { title: media.Title });
  }

  if (media.Seo?.Title) {
    return media.Seo.Title;
  }

  if (isKids) {
    return t("web_meta_title_kids", { title: media.Title });
  }

  if (isDanskFilmskat) {
    return t("web_meta_title_dfs", { title: media.Title });
  }

  if (isDanish) {
    return t("web_meta_title_danish_movies", { title: media.Title });
  }

  if (isFinnish) {
    return t("web_meta_title_finnish_movies", { title: media.Title });
  }

  return t("web_meta_fallback_title", { title: media.Title });
};

export const useMediaMetaDescription = (media: IMediaModel) => {
  const { t } = useTranslation("translations");
  const { isDanish, isFinnish, isDanskFilmskat, isKids } =
    getMediaChannelInfo(media);

  if (!media.IsPlayable) {
    return t("web_meta_description_not_available", { title: media.Title });
  }

  if (media.Seo?.Description) {
    return media.Seo.Description;
  }

  if (isKids) {
    return t("web_meta_description_kids", { title: media.Title });
  }

  if (isDanskFilmskat) {
    return t("web_meta_description_dfs", { title: media.Title });
  }

  if (isDanish) {
    return t("web_meta_description_danish_movies", { title: media.Title });
  }

  if (isFinnish) {
    return t("web_meta_description_finnish_movies", { title: media.Title });
  }

  return t("web_meta_description_rest", { title: media.Title });
};
